import { Theme } from '@mui/material/styles';
import { createContext } from 'react';

export type ThemeType = 'light' | 'dark';

export interface ThemeContextType {
    theme: Theme;
    type: ThemeType;
    toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType>({
    theme: {} as Theme,
    type: 'light',
    toggleTheme: () => {},
});

export default ThemeContext;
